import BaseNeededGroup from "../BaseNeededGroup";
import {PlatformNeededGroups} from "../NeededGroups";
import {PlatformReportingFilterType} from "../ReportingFilterType";
import {ReportVerticalType} from '../../../enums/ReportVerticalType';
import {alias, define, singleton} from '@injex/core';

@define()
@singleton()
@alias('PlatformReportingFilter')
export default class ServerAppFilter extends BaseNeededGroup {

	public type = PlatformReportingFilterType.ServerApp;

	constructor() {
		super(ReportVerticalType.PLATFORM, PlatformNeededGroups.Apps);
	}
}
